export const MIN_SIZE_VALUE = 0;

export const DEFAULT_TRADE_SIZE = 1;
